import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy-loaded route components
const EventReports = React.lazy(() =>
  import("@/modules/reports/features/EventReports").then((m) => ({
    default: m.EventReports,
  })),
);
const ReportsList = React.lazy(() =>
  import("@/modules/reports/features/EventReports/components/ReportsList").then(
    (m) => ({ default: m.ReportsList }),
  ),
);
const ReportViewer = React.lazy(() =>
  import(
    "@/modules/reports/features/EventReports/components/ReportViewer"
  ).then((m) => ({ default: m.ReportViewer })),
);

// Create stable component reference
const ReportsMainLayout = () => <MainLayout section="admin" />;

const ReportsRoutes = (
  <Route
    element={<AuthenticationGuard component={ReportsMainLayout} />}
    path="/admin"
  >
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <EventReports />
        </PermissionGuard>
      }
      path="reports"
    >
      <Route element={<ReportsList />} index />
      <Route element={<ReportViewer />} path=":reportType" />
    </Route>
  </Route>
);

export default ReportsRoutes;
